<template>
	<div class="category">
		<section class="section--page relative">
			<v-container>
				<h1 class="text-center">{{item.NAME}}</h1>
				<h4 v-if="item.UF_SUBTITLE" class="text-center color-black mt-1">{{item.UF_SUBTITLE}}</h4>

				<div v-if="filters && filters.length" class="category__top">
					<div>
						<div class="size4">
                            <!--OUR PRALINES COME IN BOXES.<br />
                            MAKE YOUR CHOICE AND FILL IT WITH THE FLAVOURS-->
							<span v-html="texts.CATEGORY_IN_BOXES.TEXT_1"></span>
							<template v-if="flavour">
								<br />
								<span v-html="texts.CATEGORY_THE_ONE.TEXT_1"><!--THE ONE YOU'VE PICKED WILL BE ALREADY INSIDE.--></span>
							</template>

						</div>

						<div class="category__filter">
							<ul>
								<li>Pcs:</li>
								<template v-for="(item, index) of filters">
									<li :class="{active:item.isActive}" @click="item.isActive = !item.isActive">
										<svgicon v-if="item.isActive" name="checkbox-on"/>
										<svgicon v-else name="checkbox-off"/>
										<span>{{item.name}}</span>
									</li>
									<!--<li v-if="index+1<filters.length"><span class="product-list__filter__dot"></span></li>-->
								</template>
							</ul>
						</div>
					</div>
				</div>

			</v-container>

			<product-list v-if="filteredProducts && filteredProducts.length"
						  :items="filteredProducts" :category="item" :flavour="flavour"/>
			<p v-else class="text-center">{{ commonTexts.SORRY.NAME }}</p>
		</section>
	</div>
</template>

<script>

	import ProductList from "@/views/Category/product-list";

	export default {
		name: "Category",
		components: {
			ProductList,
		},
		props: {
			code: {
				default: null,
				type: String,
			}
		},
		data() {
			return {
				filters: null,
				/*filters: [
					{min: 0, max: 4, name: "2-4", isActive: false},
					{min: 6, max: 9, name: "6-9", isActive: false},
					{min: 18, max: 1000, name: "18+", isActive: false},
				]*/
			}
		},
		computed: {
			categories() {
				return this.$store.state.common.sections;
			},
			item() {
				return this.$store.state.page.CategoryController.section;
			},
			flavour() {
				return this.$store.state.page.CategoryController.flavour;
			},
			products() {
				//return this.$store.state.page.CategoryController.items.filter(el=>!el.IS_SEASON);
				return this.$store.state.page.CategoryController.items;
			},
            texts() {
                return this.$store.state.page.CategoryController.texts;
            },
            commonTexts() {
                return this.$store.state.common?.texts;
            },
			/*filters() {
				//return this.filters.filter(f => this.products.some(p => p.PCS && Number(p.PCS) >= f.min && Number(p.PCS) <= f.max));
			},*/
			filteredProducts() {
				//if (!this.filters?.length) return this.items;
				const filters = this.filters?.filter(f => f.isActive);
				if (!filters?.length) return this.products;
				return this.products.filter(p => filters.some(f => p.PCS && Number(p.PCS) >= f.min && Number(p.PCS) <= f.max));
			},
		},
		methods: {
			initFilters() {
				if ( !this.item.UF_FILTERS) return null;
				const filters = this.item.UF_FILTERS.split(";").map(el=>{
					el = el.trim();
					let name = el;
					let min = 0, max = 0;
					if ( el.match(/^\d+\-\d+$/)) {
						min = Number(el.replace(/^(\d+)\-\d+$/, "$1"));
						max = Number(el.replace(/^\d+\-(\d+)$/, "$1"));
					}
					else if ( el.match(/^\d+\-$/)) {
						min = 0;
						max = Number(el.replace(/^(\d+)\-$/, "$1"));
					}
					else if ( el.match(/^\d+\+$/)) {
						min = Number(el.replace(/^(\d+)\+$/, "$1"));
						max = 1000;
					}
					return {
						name,
						min,
						max,
						isActive: false
					}
				});

				this.filters = filters;
			}
		},
		mounted() {
			this.initFilters();
		}
	}
</script>

<style lang="scss">
	.category {

		&__top{
			position: relative;
			z-index: $z-highest - 2;	// -1 = header

			margin: 20px 0;
			display: flex;
			justify-content: center;

			@include up($sm) {
				margin: 40px 0;
			}

			& > div {
				background: $white-alpha2;
				.size4 {
					border-top: 1px solid $golden;
					border-bottom: 1px solid $golden;
					text-align: center;
					color: $black;
					padding: 16px 8px;
					line-height: 20px;
				}
			}
		}

		&__filter {
			border-bottom: 1px solid $golden;
			display: flex;
			justify-content: center;

			ul {
				display: flex;
				//flex-direction: column;
				//flex-direction: row;
				justify-content: center;
				align-content: center;
				padding: 8px !important;
				text-transform: uppercase;

				@include up($sm) {
					padding: 10px !important;
				}

				li {
					position: relative;
					cursor: pointer;
					display: flex;
					align-items: center;
					padding: 2px 4px !important;
					margin-left: 12px !important;

					&:first-child {
						margin-left: 0 !important;
					}

					&.active, &:hover {
						color: $golden;

						svg {
							opacity: 1;
							fill: $golden;
						}
					}

					svg {
						flex-shrink: 0;
						width: 16px;
						height: 16px;
						/*left: 10px;
						top: 20px;
						right: unset;*/
						margin-right: 8px;
						//fill: $default-text-color;

						opacity: 0.5;
						@include transition();
					}
				}
			}

			&__dot {
				display: none;
				width: 3px;
				height: 3px;
				border-radius: 100%;
				background: $black-50;
				margin: 0 12px;

				@include up($sm) {
					display: inline-block;
				}
			}
		}


		/*&-animation {
			//position: relative;
			//height: 180px;
			//margin-top: 30px;

			img, div {
				position: absolute;
				opacity: 0;
			}

			@include up($md) {
				//height: auto;
				//margin-top: 0;
				position: absolute;

				width: 0;
				//max-width: $lg;
				height: 480px;

				left: 50%;
				top: 100px;
				transform: translate(-50%) scale(1);
			}

			!*&-clip {
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%) scale(0.55);

				@include up($md) {
					top: unset;
					left: unset;
					transform: translate(-27%) scale(0.7);
					position: relative;
				}

				@include up($lg) {
					top: unset;
					left: unset;
					transform: translate(-33%) scale(0.9);
					position: relative;
				}
			}*!
		}*/
	}
</style>